<form [formGroup]="form" (ngSubmit)="findStudyReportLogisticsInfo()">
    <mat-form-field class="full-width">
        <input type="text" matInput placeholder="Protocolo" formControlName="protocol" autofocus required>
        <button matSuffix type="submit" mat-icon-button>
      <mat-icon>search</mat-icon>
    </button>
        <mat-error *ngIf="f.protocol.errors && f.protocol.errors.required">
            Ingrese el número de protocolo
        </mat-error>
    </mat-form-field>
</form>
<mat-spinner *ngIf="loading"></mat-spinner>
<div *ngIf="!loading">
    <div *ngFor="let item of items">
        <h4>Paciente: </h4> {{item.PatientFullName}}
        <br>
        <h4>Práctica: </h4> {{item.PracticeRegionName}}
        <br>
        <h4>Sector: </h4> {{item.TransitSector}}
        <br>
        <h4>Estado: </h4> {{item.TransitState}}
    </div>
    <div *ngIf="items.length == 0 && isSubmited">
        <h4>No se ha encontrado información</h4>
    </div>
</div>